export const calculatepercent = (value,per) =>{
    try{
        if(value == 0 || value == ''){
            return 0;     
        }else{

            // console.log(per,'percent ');
            // console.log(value,'percent2 ');
            let cal =  ((per*value) / 100);
            return cal;     
        } 
            
    }catch(error){
        //  return 0;
         console.log(error);   
    }
}


function roundToTwoDecimalPlaces(num) {
    return Math.round(num * 100) / 100;
  }


export const calculatepercent2 = (value,per) =>{
    try{
        if(value == 0 || value == ''){
            return 0;     
        }else{

            let cal =  ((per/value) * 100);
            return roundToTwoDecimalPlaces(cal);
            return cal;     
        } 
    }catch(error){
         console.log(error);   
    }
}

export const calculatepercent3 = (per,value) =>{
    try{
        if(value == 0 || value == ''){
            return 0;     
        }else{

            let cal =  ((per/100) * value);
            return roundToTwoDecimalPlaces(cal);
            return cal;     
        } 
    }catch(error){
         console.log(error);   
    }
}

